import React from 'react';
import styled, { keyframes } from 'styled-components';
import Logo from '../../assets/images/dwlogo_wide.png';

const LoadingScreen = () => {
    return (
        <ScreenWrapper>
            <ContentContainer>
                <LogoImage src={Logo} alt="DWM Logo" />
                <SpinnerWrapper>
                    <Spinner />
                </SpinnerWrapper>
                <LoadingText>Initializing Application...</LoadingText>
            </ContentContainer>
        </ScreenWrapper>
    );
};

export default LoadingScreen;

// Animations
const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
`;

// Styled Components
const ScreenWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
`;

const LogoImage = styled.img`
    height: 60px;
    width: auto;
    animation: ${pulse} 2s infinite ease-in-out;
    
    @media (max-width: 768px) {
        height: 48px;
    }
`;

const SpinnerWrapper = styled.div`
    position: relative;
    width: 48px;
    height: 48px;
`;

const Spinner = styled.div`
    width: 100%;
    height: 100%;
    border: 4px solid rgba(130, 22, 146, 0.1);
    border-top: 4px solid #701a82;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.p`
    color: #6b7280;
    font-size: 0.875rem;
    font-weight: 500;
    margin: 0;
    letter-spacing: 0.05em;
    animation: ${pulse} 1.5s infinite ease-in-out;
`;
